import GooglePay from './views/google-pay.c';
export default GooglePay;
